import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'comp-cotizaciones-index-detalles',
  templateUrl: './detalles.component.html',
  styleUrls: ['./detalles.component.css']
})
export class CotizacionesIndexDetallesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
